// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-c0f2cb7c{to{stroke-dashoffset:0}}.back-to-top-btn[data-v-c0f2cb7c]{text-align:center;width:62px;z-index:1}.back-to-top-btn img[data-v-c0f2cb7c]{max-height:100%;max-width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
